import ApiManager from '../../utils/ApiManager'
import Constants from '../../utils/Constants'

const state = {
  list: {
    loading: false,
    totalItems: 0,
    rowsPerPage: 20,
    headers: [
      { text: '企業名', align: 'left', value: 'contract_name', sortable: false },
      { text: 'ユーザー名', align: 'left', value: 'user_name', sortable: false },
      { text: 'ユーザーID', align: 'left', value: 'user_id', sortable: false, type: 'link' },
      { text: 'メールアドレス', align: 'left', value: 'email', sortable: false },
      { text: 'サービス区分', align: 'left', value: 'pos_flag', sortable: false },
      { text: '管理者', align: 'left', value: 'role', sortable: false },
      { text: '月間<br/>分析回数', align: 'left', value: 'monthly_analyze_number', sortable: false },
      { text: '月間<br/>分析量', align: 'left', value: 'monthly_analyze_capacity', sortable: false },
      { text: '月間<br/>分析件数', align: 'left', value: 'monthly_analyze_count', sortable: false },
      { text: '履歴件数', align: 'left', value: 'histories_count', sortable: false },
      { text: '商品グル<br/>ープ件数', align: 'left', value: 'product_groups_count', sortable: false },
      { text: '店舗グル<br/>ープ件数', align: 'left', value: 'shop_groups_count', sortable: false },
      { text: '会員グル<br/>ープ件数', align: 'left', value: 'member_groups_count', sortable: false },
      { text: '商品カテゴリ<br/>グループ件数', align: 'left', value: 'product_category_groups_count', sortable: false },
      { text: '一時停止', align: 'left', value: 'stop_flag', sortable: false },
      { text: '終了日', align: 'left', value: 'active_to', sortable: false },
      { text: '登録日', align: 'left', value: 'created', sortable: false },
      { text: '更新日', align: 'left', value: 'modified', sortable: false },
      { text: '更新者', align: 'left', value: 'editor_name', sortable: false }
    ],
    items: [],
    contract_users_count: 0
  },
  contractList: [],
  message: {
    content: '',
    type: ''
  },
  searchCondition: {
    freeword: '',
    contractId: null
  }
}

const actions = {
  /**
   * ユーザー一覧データ取得
   */
  async getUserList ({ state, commit }, { pageNo, rowsPerPage, sortField, sortType, freeword, contractId }) {
    commit('setListLoading', true)
    commit('setSearchCondition', {
      freeword: freeword,
      contractId: contractId
    })
    const response = await ApiManager.request('User').userList(
      pageNo,
      rowsPerPage,
      sortField,
      sortType ? '-' : null,
      freeword,
      contractId
    )
    const message = {
      type: 'success',
      content: ''
    }
    if (response.data.code === Constants.ResponseCode.SUCCESS) {
      commit('setList', response.data)
    } else if (response.data.code === Constants.ResponseCode.VALIDATE_ERROR) {
      message.type = 'error'
      message.content = response.data.data.message
    }
    commit('setMessage', message)
  },

  async getContractList ({ state, commit }) {
    const response = await ApiManager.request('Contract').contractList()
    const message = {
      type: 'success',
      content: ''
    }
    if (response.data.code === Constants.ResponseCode.SUCCESS) {
      commit('setContractList', response.data)
    } else if (response.data.code === Constants.ResponseCode.VALIDATE_ERROR) {
      message.type = 'error'
      message.content = response.data.data.message
    }
    commit('setMessage', message)
  },

  /**
   * group delete
   */
  async deleteUser ({ state, commit }, deleteIds) {
    commit('setListLoading', true)
    const response = await ApiManager.request('User').userDelete(deleteIds)
    if (response.data.code === 200000) {
    } else {
      commit('setMessage', { content: response.data.data.message, type: 'error' })
      commit('setListLoading', false)
    }
    this.dispatch('loading/loadingPageMinus')
  }
}

const mutations = {
  setMessage (state, data) {
    state.message = data
  },
  setSearchCondition (state, data) {
    state.searchCondition = data
  },
  setListLoading (state, data) {
    // Listローディング状態
    state.list.loading = data
    this.dispatch('loading/loadingPagePlus')
  },
  setList (state, data) {
    state.list.items = data.data
    state.list.totalItems = data.meta.count
    state.list.contract_users_count = data.meta.users_count
    state.list.loading = false
    this.dispatch('loading/loadingPageMinus')
  },
  setContractList (state, data) {
    state.contractList = [{ id: '', name: '' }].concat(data.data)
  }
}

const getters = {
  get: state => {
    return state
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
